// extracted by mini-css-extract-plugin
export default {"form":"form__vB6Js907h2yO","EditorDropzone":"EditorDropzone__rDlcN4c0u3TL"};